import { Checkbox, Pane, Text } from '@leverege/ui-elements';
import React from 'react';
import { SwatchAndColor } from '../../../attributes/renderers/vehicle';
import Detail from './Detail';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmLocatorPresent(props) {
  const {
    sale,
    onChange,
    formState
  } = props;
  const {
    locatorPresent
  } = formState;
  const customer = sale.data?.data?.customer;
  const vehicle = sale.data?.data?.vehicle;
  const locator = sale.data?.data?.locator;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Customer Information"
    }), /*#__PURE__*/_jsx(CustomerInfoCard, {
      customer: customer
    }), /*#__PURE__*/_jsx(VehicleInfoCard, {
      vehicle: vehicle,
      locator: locator
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Confirm Customer Presence"
    }), /*#__PURE__*/_jsx(Checkbox, {
      variant: "locatorReplacement",
      label: "This customer and vehicle are present at the dealership.",
      value: locatorPresent,
      onChange: onChange,
      eventData: "locatorPresent"
    })]
  });
}
function CustomerInfoCard({
  customer
}) {
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    children: /*#__PURE__*/_jsx(Pane, {
      layout: "flex:rowXXL",
      variant: "dataCard",
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(Detail, {
          label: "Customer",
          value: customer.name
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Account Email",
          value: customer.email
        })]
      })
    })
  });
}
function VehicleInfoCard({
  vehicle,
  locator
}) {
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    children: /*#__PURE__*/_jsx(Pane, {
      layout: "flex:rowXXL",
      variant: "dataCard",
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(Detail, {
          label: "VIN",
          value: vehicle.vin
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Vehicle",
          value: `${vehicle.year} ${vehicle.make} ${vehicle.model}`
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Color",
          value: /*#__PURE__*/_jsx(SwatchAndColor, {
            colorName: vehicle.colorName
          })
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Original Locator ID",
          value: locator.serialNumber
        })]
      })
    })
  });
}